"use client";

import {
  LeaderPieChart,
  getPieChartDataFromDecklists,
} from "@/components/MetaReport/LeaderPieChart";
import dynamic from "next/dynamic";
import { IDecklistV2 } from "@/models/decklist";
import { SupportedGames } from "@/types/game";
import { useEffect } from "react";
import { setPalworldCards } from "@/lib/games/palworld/getCardDataLocal";
import type { PalworldItem } from "@/interfaces/CardItem";
import type { PalworldAaData } from "@/lib/games/palworld/getCardData";

// Dynamically import video ad components to avoid hydration issues
const DomainVideoAd = dynamic(() => import("@/components/Ads/DomainVideoAd"), {
  ssr: false,
});

interface EventPieChartAndVideoProps {
  decklists: IDecklistV2[];
  game: SupportedGames;
  palworldCards?: PalworldItem[];
  palworldAaData?: PalworldAaData;
}

export default function EventPieChartAndVideo({
  decklists,
  game,
  palworldCards,
  palworldAaData,
}: EventPieChartAndVideoProps) {
  // Set Palworld cards on client side for archetype derivation
  useEffect(() => {
    if (game === "palworld" && palworldCards && palworldAaData) {
      setPalworldCards(palworldCards, palworldAaData);
      console.log("[EventPieChart] Set Palworld cards:", palworldCards.length);
    }
  }, [game, palworldCards, palworldAaData]);

  // Process decklists data for pie chart using the new function that handles Palworld archetypes
  const pieChartData = getPieChartDataFromDecklists(decklists, game);

  return (
    <>
      <div className="mb-6 flex flex-row rounded-md">
        <div className="h-[360px] flex flex-col items-center justify-center bg-slate-900 pie-chart-wrapper w-full">
          <div className="text-lg font-semibold mb-2 text-center">
            Tournament Leaders
          </div>
          <LeaderPieChart data={pieChartData} tooltipLabel="Count" />
        </div>
        <div className="relative h-[360px] min-w-[640px] video-desktop">
          <DomainVideoAd screen={"desktop"} alias="event-video-desktop" />
        </div>
      </div>

      <div className="video-mobile mb-4 h-[250px]">
        <DomainVideoAd screen={"mobile"} alias="event-video-mobile" />
      </div>
    </>
  );
}
